// extracted by mini-css-extract-plugin
export var root = "C_vt";
export var wrapper = "C_vv";
export var image = "C_vw d_w d_y d_W";
export var imageWithHeight = "C_vx";
export var crop = "C_vy";
export var round = "C_vz";
export var fixedHeight = "C_vB";